export default function FinanzasFilters({ filters, onChange, onApply, onReset, loading, errors = {}, formError = '' }) {
  const isApplyDisabled = loading;

  const getErrorMessage = (error) => {
    if (!error) return '';
    return Array.isArray(error) ? error[0] : error;
  };

  const fieldClass = (hasError) =>
    `w-full rounded-2xl border bg-white px-4 py-3 text-sm text-gray-900 shadow-sm transition
     ${hasError ? 'border-red-400 ring-2 ring-red-200 focus:ring-red-300 focus:border-red-400'
      : 'border-gray-200 focus:ring-2 focus:ring-red-200 focus:border-red-300'}`;

  return (
    <section className="space-y-4">
      {/* Banda de error del formulario (422) */}
      {!!formError && (
        <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-red-700 text-sm" role="alert" aria-live="polite">
          {formError}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
        {/* FECHA INICIO */}
        <div>
          <label htmlFor="fecha_inicio" className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2">
            FECHA INICIO
          </label>
          <input
            id="fecha_inicio"
            name="fecha_inicio"
            type="date"
            value={filters.fecha_inicio || ''}
            onChange={onChange}
            className={fieldClass(!!errors.fecha_inicio)}
            aria-invalid={!!errors.fecha_inicio}
            aria-describedby={errors.fecha_inicio ? 'fecha_inicio_error' : undefined}
          />
          <div className="h-5">
            {!!errors.fecha_inicio && (
              <p id="fecha_inicio_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.fecha_inicio)}
              </p>
            )}
          </div>
        </div>

        {/* FECHA FIN */}
        <div>
          <label htmlFor="fecha_fin" className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2">
            FECHA FIN
          </label>
          <input
            id="fecha_fin"
            name="fecha_fin"
            type="date"
            value={filters.fecha_fin || ''}
            onChange={onChange}
            className={fieldClass(!!errors.fecha_fin)}
            aria-invalid={!!errors.fecha_fin}
            aria-describedby={errors.fecha_fin ? 'fecha_fin_error' : undefined}
          />
          <div className="h-5">
            {!!errors.fecha_fin && (
              <p id="fecha_fin_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.fecha_fin)}
              </p>
            )}
          </div>
        </div>

        {/* ABONADO POR */}
        <div>
          <label htmlFor="abonado_por" className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2">
            ABONADO POR
          </label>
          <select
            id="abonado_por"
            name="abonado_por"
            value={filters.abonado_por || ''}
            onChange={onChange}
            className={`${fieldClass(!!errors.abonado_por)} bg-white`}
            aria-invalid={!!errors.abonado_por}
            aria-describedby={errors.abonado_por ? 'abonado_por_error' : undefined}
          >
            <option value="">TODOS</option>
            <option value="CUENTA CORRIENTE">CUENTA CORRIENTE</option>
            <option value="CAJA CHICA">CAJA CHICA</option>
          </select>
          <div className="h-5">
            {!!errors.abonado_por && (
              <p id="abonado_por_error" className="mt-1 text-xs text-red-600">
                {getErrorMessage(errors.abonado_por)}
              </p>
            )}
          </div>
        </div>

        {/* Acciones - ocupa toda la fila en mobile y 3 columnas en desktop */}
        <div className="flex flex-col sm:flex-row gap-3 md:col-span-3">
          <button
            type="button"
            onClick={onApply}
            disabled={isApplyDisabled}
            aria-busy={loading}
            className="w-full sm:flex-1 rounded-full bg-red-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 hover:shadow-md disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            {loading ? 'Cargando…' : 'Aplicar'}
          </button>

          <button
            type="button"
            onClick={onReset}
            disabled={loading}
            className="w-full sm:flex-1 rounded-full border border-red-200 bg-white px-6 py-3 text-sm font-semibold text-red-600 shadow-sm transition hover:border-red-300 hover:bg-red-50 disabled:opacity-70 disabled:cursor-not-allowed"
          >
            Limpiar
          </button>
        </div>
      </div>
    </section>
  );
}

